import { Route, Routes } from "react-router-dom"
import AddRecruitment from "./pages/AddRecruitment"
import EditRecruitment from "./pages/EditRecruitment"
import List from "./pages/List"

export const RecruitmentRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<EditRecruitment />} />
      <Route path="/create" element={<AddRecruitment />} />
    </Routes>
  )
}
